const extractMessageFromDetail = (detail) => {
  if (!detail) return null;

  if (typeof detail === "string") return detail;

  if (Array.isArray(detail)) {
    return detail
      .map((item) => item?.msg)
      .filter(Boolean)
      .join(", ");
  }

  if (typeof detail === "object") {
    return detail.msg || detail.message || null;
  }

  return null;
};

export const getErrorMessage = (error) => {
  if (!error) return "Ошибка авторизации";
  if (typeof error === "string") return error;

  if (error.type === "network") {
    return "Ошибка сети. Проверьте подключение к интернету.";
  }

  if (error.type === "auth") {
    return error.message || "Сессия истекла. Войдите заново.";
  }

  if (error.type === "http") {
    if (error.status >= 500) {
      return "Серверная ошибка, повторите попытку позже";
    }

    return (
      error.data?.detail ||
      error.detail ||
      error.data?.message ||
      error.message ||
      extractMessageFromDetail(error.data?.detail) ||
      extractMessageFromDetail(error.detail) ||
      "Ошибка авторизации"
    );
  }

  return (
    error.data?.detail ||
    error.detail ||
    error.data?.message ||
    error.message ||
    extractMessageFromDetail(error.data?.detail) ||
    extractMessageFromDetail(error.detail) ||
    "Ошибка авторизации"
  );
};
